import Base from '../base';

const randomVal = () => Math.floor(Math.random() * 99);
const randomAmount = () => (Math.random() * 1200).toFixed(2);
const container = document.getElementById('market-sentiment-container');

const mockData = (amount) => {
	const arr = [];

	for (let i = 0; i < amount; i++) {
		const a = randomVal();

		arr.push([a, 100 - a]);
	}

	return arr;
};

class MarketSentimentLarge extends Base {
	start() {
		this.setData();
		this.createBars();
	}

	setData() {
		this.data = mockData(10);
	}

	createBars() {
		this.data.forEach((e) => {
			const indicator = document.createElement('div');

			indicator.className = 'card';
			container.appendChild(indicator);
			indicator.innerHTML = this.fillBars(e);
		});
	}

	// eslint-disable-next-line class-methods-use-this
	fillBars(values) {
		const bar = `
			<div class="market-sentiment-large">
				<div class="market-sentiment-large__section market-sentiment-large__section--start">
					<div class="market-sentiment-large__main">Underlying</div>
					<div>${randomAmount()} <span class="market-sentiment-large__secondary">EUR</span></div>
				</div>

				<div class="market-sentiment-large__values">
					<div class="market-sentiment-large__bar">
						<div style="width: ${values[0]}%" class="market-sentiment-large__value market-sentiment-large__value--bull">${values[0]}%</div>
						<div style="width: ${values[1]}%" class="market-sentiment-large__value market-sentiment-large__value--bear">${values[1]}%</div>
					</div>

				</div>

				<div class="market-sentiment-large__section market-sentiment-large__section--end">
					<div class="market-sentiment-large__main">HH:MM</div>
					<div class="market-sentiment-large__secondary">13-08-2019</div>
				</div>
			</div>
		`;

		return bar;
	}
}

export default MarketSentimentLarge;
